import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';

export type ScrollIndicatorTheme = 'dark&gray' | 'dark&white';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-scroll-indicator',
  templateUrl: './scroll-indicator.component.html',
})
export class ScrollIndicatorComponent {
  public readonly stepCount = input.required<number>();
  public readonly theme = input<ScrollIndicatorTheme>('dark&gray');

  public readonly stepIterable = computed(() => {
    return Array.from({ length: this.stepCount() });
  });

  public readonly progress = input.required<number>();

  public readonly activeStepIndex = computed(() => {
    const stepCount = this.stepCount();
    if(stepCount < 2) {
      return 1;
    }

    const progress = this.progress();

    return Math.round(progress * (stepCount - 1));
  });
}
